<div class="time-picker-container" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <div class="time-picker-input-wrapper" [class.error]="inputError()" [class.time-picker-input-wrapper--flush-right]="flushRight()">
    <input
      [zagScrollIntoView]="true"
      type="text"
      class="time-picker-input"
      [class.disabled]="disabled()"
      [class.readonly]="readonly()"
      [disabled]="disabled()"
      [readonly]="readonly() || isMobile()"
      [attr.id]="id()"
      [attr.name]="name()"
      [attr.placeholder]="maskInput() ? maskPlaceholder() : placeholder()"
      [attr.aria-label]="placeholder()"
      [attr.aria-invalid]="inputError()"
      [attr.aria-required]="required()"
      [attr.aria-haspopup]="'dialog'"
      [attr.aria-expanded]="open()"
      [value]="inputValue()"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()"
      (keydown)="onInputKeyDown($event)"
    />
    @if (showClearButton()) {
    <button type="button" class="clear-button" [attr.aria-label]="'timePicker.clearTime' | translate" (click)="clear($event)">
      <span zagIcon="close"></span>
    </button>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="isMobile() ? mobileOverlayPositions : overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="isMobile() ? 'zag-picker-dialog-backdrop' : 'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayPanelClass]="isMobile() ? 'zag-picker-dialog-panel' : ''"
  (backdropClick)="close()"
  (detach)="close()"
>
  <dialog class="time-picker-panel" open aria-modal="false" [attr.aria-label]="'timePicker.selectTime' | translate">
    @if (isMobile()) {
    <div class="zag-picker-mobile-header">
      @if (fieldLabel()) {
      <span class="zag-picker-mobile-header__label">{{ fieldLabel() }}</span>
      }
      <button type="button" class="zag-picker-mobile-header__close" [attr.aria-label]="'picker.close' | translate" (click)="close()">
        <span zagIcon="close"></span>
      </button>
    </div>
    }
    <div class="time-controls" [attr.aria-label]="'timePicker.selectTime' | translate">
      <!-- Hours scroll column (looped for infinite scroll when enough items) -->
      <div
        class="scroll-column"
        [class.scroll-column--looped]="isHoursLooped()"
        role="listbox"
        [attr.aria-label]="'timePicker.hours' | translate"
        (scroll)="onColumnScroll($event)"
      >
        @for (h of loopedHours(); track $index) {
        <button
          type="button"
          class="scroll-column__item"
          [class.scroll-column__item--selected]="isHourSelected(h)"
          role="option"
          [attr.aria-selected]="isHourSelected(h)"
          [attr.aria-label]="('timePicker.hours' | translate) + ' ' + displayHourFor(h)"
          (click)="selectHour(h % 24)"
        >
          {{ displayHourFor(h) }}
        </button>
        }
      </div>

      <span class="time-separator" aria-hidden="true">:</span>

      <!-- Minutes scroll column (looped for infinite scroll when enough items) -->
      <div
        class="scroll-column"
        [class.scroll-column--looped]="isMinutesLooped()"
        role="listbox"
        [attr.aria-label]="'timePicker.minutes' | translate"
        (scroll)="onColumnScroll($event)"
      >
        @for (m of loopedMinutes(); track $index) {
        <button
          type="button"
          class="scroll-column__item"
          [class.scroll-column__item--selected]="isMinuteSelected(m)"
          role="option"
          [attr.aria-selected]="isMinuteSelected(m)"
          [attr.aria-label]="('timePicker.minutes' | translate) + ' ' + m"
          (click)="selectMinute(m % 60)"
        >
          {{ m | number: '2.0' }}
        </button>
        }
      </div>

      @if (showSeconds()) {
      <span class="time-separator" aria-hidden="true">:</span>

      <!-- Seconds scroll column (always looped — 60 items) -->
      <div
        class="scroll-column scroll-column--looped"
        role="listbox"
        [attr.aria-label]="'timePicker.seconds' | translate"
        (scroll)="onColumnScroll($event)"
      >
        @for (s of loopedSeconds; track $index) {
        <button
          type="button"
          class="scroll-column__item"
          [class.scroll-column__item--selected]="isSecondSelected(s)"
          role="option"
          [attr.aria-selected]="isSecondSelected(s)"
          [attr.aria-label]="('timePicker.seconds' | translate) + ' ' + s"
          (click)="selectSecond(s % 60)"
        >
          {{ s | number: '2.0' }}
        </button>
        }
      </div>
      } @if (format() === '12h') {
      <!-- Period scroll column -->
      <div class="scroll-column scroll-column--period" role="listbox" [attr.aria-label]="'timePicker.period' | translate">
        @for (p of periods; track p) {
        <button
          type="button"
          class="scroll-column__item"
          [class.scroll-column__item--selected]="isPeriodSelected(p)"
          role="option"
          [attr.aria-selected]="isPeriodSelected(p)"
          [attr.aria-label]="p"
          (click)="selectPeriod(p)"
        >
          {{ p }}
        </button>
        }
      </div>
      }
    </div>

    <div class="time-actions">
      <button type="button" class="action-button secondary" [disabled]="disabled() || readonly()" (click)="setNow()">
        {{ 'timePicker.now' | translate }}
      </button>
      <button type="button" class="action-button primary" (click)="apply()">{{ 'timePicker.set' | translate }}</button>
    </div>
  </dialog>
</ng-template>
